var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVrSpend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 49,
    viewBox: "0 0 44 49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    stroke: "#E10A0A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.648 2H8.723S6.35 25.104 20.393 33.434a3.522 3.522 0 0 0 3.566 0C38 25.104 35.648 2 35.648 2zM22.653 33.918v12.204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.146 8.571h2.73c1.936 0 3.491 1.594 3.491 3.568v2.337c0 3.17-1.302 6.23-3.67 8.295-1.538 1.322-3.672 2.409-6.656 2.698M8.221 8.571h-2.73C3.554 8.571 2 10.165 2 12.14v2.337c0 3.17 1.302 6.23 3.671 8.295 1.537 1.322 3.672 2.409 6.656 2.698M13.265 47.061h18.776M28.286 19.837c.488-1.51.9-3.148 1.22-4.915.413-2.32.6-4.51.657-6.35"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVrSpend);
export default __webpack_public_path__ + "static/media/icon-vr-spend.531cbec8f0db1a8b626874e3b8c10692.svg";
export { ForwardRef as ReactComponent };